import { render } from "./FathersDayOverlay.vue?vue&type=template&id=1819611d&scoped=true"
import script from "./FathersDayOverlay.vue?vue&type=script&lang=js"
export * from "./FathersDayOverlay.vue?vue&type=script&lang=js"

import "./FathersDayOverlay.vue?vue&type=style&index=0&id=1819611d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1819611d"]])

export default __exports__